/* PageHeader — MUI title + subtitle + right-aligned action cluster. */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Stack, Typography} from '@mui/material'

export default function PageHeader({title, sub, actions}) {
  return (
    <Stack
      direction={{xs: 'column', sm: 'row'}}
      alignItems={{sm: 'flex-start'}}
      justifyContent='space-between'
      spacing={1.5}
      sx={{mb: 2.5}}
    >
      <Box sx={{minWidth: 0}}>
        <Typography component='h1' sx={{fontSize: 24, fontWeight: 800, letterSpacing: '-.02em', color: 'text.primary', lineHeight: 1.2, m: 0}}>
          {title}
        </Typography>
        {sub ? <Typography sx={{fontSize: 13.5, color: 'text.secondary', mt: 0.5, maxWidth: 780}}>{sub}</Typography> : null}
      </Box>
      {actions ? <Box sx={{display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', flexShrink: 0}}>{actions}</Box> : null}
    </Stack>
  )
}

PageHeader.propTypes = {
  title: PropTypes.node,
  sub: PropTypes.node,
  actions: PropTypes.node,
}
